/**
 * Test IDs for the Sprint 0 foundation shell (system status page + layouts).
 */
export const LAYOUT = {
	publicShell: 'public-layout-shell',
	adminShell: 'admin-layout-shell',
};

export const SYSTEM = {
	page: 'system-status-page',
	backendCard: 'system-backend-card',
	backendStatus: 'system-backend-status',
	databaseStatus: 'system-database-status',
	refreshButton: 'system-refresh-button',
	rolesList: 'system-roles-list',
	layersList: 'system-layers-list',
	publicMunicipalities: 'system-public-municipalities',
	publicEvents: 'system-public-events',
	tenantStrategy: 'system-tenant-strategy',
	adminLink: 'system-admin-link',
};

export const NOT_FOUND = {
	page: 'not-found-page',
	homeLink: 'not-found-home-link',
};

export const ADMIN = {
	page: 'admin-dashboard-page',
	homeLink: 'admin-home-link',
};
